import { ColumnConfigType } from 'shared/types';
import { IFinanceOperatorTableData } from 'entities/financeOperations/types';

export const columnConfig: ColumnConfigType<IFinanceOperatorTableData>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '6%',
  },
  {
    dataFieldName: 'service',
    name: 'Фин. Оператор',
    width: '30%',
  },
  {
    dataFieldName: 'country_name',
    name: 'Страна использования',
    width: '16%',
  },
  {
    dataFieldName: 'limit',
    name: 'Лимит',
    width: '16%',
  },
  {
    dataFieldName: 'type',
    name: 'Тип вывода',
    width: '16%',
  },
  {
    dataFieldName: 'app_type',
    name: 'Тип приложения',
    width: '16%',
  },
];
